import { AnaliticoComponent } from './relatorio-analitico/analitico.component';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ChamadoDadosComponent } from './dados-chamados/dados.component';
import { ChamadosCargaComponent } from './carga-chamados/carga.component';
import { ChamadosEscalationComponent } from './escalation-chamados/escalation.component';
import { ChamadosExportacaoComponent } from './exportacao-chamados/exportacao-chamados.component';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { CommonModule, DatePipe } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ErrorHandlerInterceptor } from './core/interceptor/error-handler.interceptor';
import { ExecutivoComponent } from './relatorio-executivo/executivo.component';
import { ExportacoesComponent } from './exportacoes/exportacoes.component';
import { FileUploadModule } from 'primeng/fileupload';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { InterceptorModule } from './core/interceptor/auth.interceptor.module';
import { LoginModule } from './login/login.module';
import { ManutencaoGrupoComponent } from './manutencao-grupo/manutencao-grupo.component';
import { ManutencaoProjetosComponent } from './manutencao-projetos/manutencao-projetos.component';
import { ManutencaoUsuarioComponent } from './manutencao-usuario/manutencao-usuario.component';
import { MenuBarComponent } from './menu-bar/menu-bar.component';
import { MenubarModule } from 'primeng/menubar';
import { MessageService } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';
import { NgModule } from '@angular/core';
import { OcorrenciaComponent } from './ocorrencia/ocorrencia.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PasswordModule } from 'primeng/password';
import { PhonePipe} from './shared/phone-pipe/phone.pipe';
import { RegrasAlertaComponent } from './regras-alerta/regras-alerta.component';
import { ResetSenhaComponent } from './reset-senha/reset-senha.component';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { TruncatePipe } from './shared/truncate.pipe';

@NgModule({
  declarations: [
    AnaliticoComponent,
    AppComponent,
    ChamadoDadosComponent,
    ChamadosCargaComponent,
    ChamadosEscalationComponent,
    ChamadosExportacaoComponent,
    DashboardComponent,
    ExecutivoComponent,
    ExportacoesComponent,
    ManutencaoGrupoComponent,
    ManutencaoProjetosComponent,
    ManutencaoUsuarioComponent,
    MenuBarComponent,
    OcorrenciaComponent,
    PhonePipe,
    RegrasAlertaComponent,
    ResetSenhaComponent,
    TruncatePipe
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    ButtonModule,
    CalendarModule,
    CardModule,
    ChartModule,
    CheckboxModule,
    CommonModule,
    ConfirmDialogModule,
    ConfirmPopupModule,
    DialogModule,
    DropdownModule,
    FileUploadModule,
    FormsModule,
    HttpClientModule,
    InputMaskModule,
    InputTextareaModule,
    InputTextModule,
    InterceptorModule,
    LoginModule,
    MenubarModule,
    MessagesModule,
    OverlayPanelModule,
    PaginatorModule,
    PasswordModule,
    TableModule,
    ToastModule,
    ToggleButtonModule,
    ToolbarModule,
    TriStateCheckboxModule
  ],
  providers: [
    DatePipe,
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
